import { GroupedType } from './GroupedType';

export interface IGroupedItem {
  _class: string;
  value: string;
  type: GroupedType;
}

namespace app.model.controls.grid {
  import GroupedType = app.model.controls.grid.GroupedType;
  export interface IGroupedItem {
    _class: string;
    value: string;
    type: GroupedType;
  }
}
